import React, { useState, useEffect } from "react";
import moment from 'moment';
import { connect } from "react-redux";
import styles from "./AddOrgModal.module.scss";
import Modal from "components/Modal/Modal";
import FormElement from "components/FormElement/FormElement";
// import Select from "components/Select/Select";
import Button from "components/Button/Button";
import {
    createOrgAction,
    loadActsAction,
    loadActsAllAction,
} from "store/actions/Actions";
import Checkbox from "components/Checkbox/Checkbox";

const AddOrgModal = (props) => {
    const {
        createOrgAction,
        // loadActsAction,
        loadActsAllAction,
        ActsReducer
    } = props;

    const [formData, setFormData] = useState({
		name: "",
        customer_id: "",
		address_1: "",
		address_2: "",
		city: "",
		region: "",
		postal_code: "",
		country_code: 235,
        active: true,
        site_limit: 1,
        acts: [],
    });

    const [stateErrors, setStateErrors] = useState({
        name: "",
        customer_id: ""
    });

    // useEffect(() => {
    //     if (!ActsReducer.acts) {
    //         loadActsAction();
    //     }
    // }, [ActsReducer.acts, loadActsAction]);

    useEffect(() => {
        if (!ActsReducer.all) {
            loadActsAllAction();
        } else {
            setFormData((s) => ({
                ...s,
                acts: ActsReducer.all.filter(a => a.checked === "t").map(b => parseInt(b.id)),
            }))
        }
    }, [ActsReducer.all, loadActsAllAction]);

    const handleChange = (e) => {
        const val = (e.target && e.target.value) ? e.target.value : '';
        e.persist();
        setFormData((s) => ({ ...s, name: val }));
    };

    const handleIdChange = (e) => {
        const val = (e.target && e.target.value) ? e.target.value : '';
        e.persist();
        setFormData((s) => ({ ...s, customer_id: val }));
    };

    const handleLimitChange = (e) => {
        const val = (e.target && e.target.value) ? e.target.value : '';
        e.persist();
        setFormData((s) => ({ ...s, site_limit: val }));
    };

    const handleActs = (e) => {
        let a = formData.acts.slice();
        if (e.target.checked === true) {
            a.push(Number(e.target.value));
        } else {
            a = a.filter((item) => item !== Number(e.target.value));
        }
        setFormData((s) => ({
            ...s,
            acts: a,
        }));
    }

    const addModal = (e) => {
        if (formData.name !== "" && formData.customer_id !== "") {
            createOrgAction(formData);
            props.setShowModal(false);   
            return false;   
        } else {

            if (formData.name === ""){
                setStateErrors((s) => ({
                    ...s,
                    name: "Organization name is required",
                }));
            }

            if (formData.customer_id === ""){
                setStateErrors((s) => ({
                    ...s,
                    customer_id: "Infusionsoft Id is required",
                }));
            }

            return false;
        }
    }

    return (
        <Modal className={styles.modal} setShowModal={props.setShowModal}>
            <p className={styles["modal-heading"]}>Create new organization</p>

            <div className={styles["modal-content"]}>
                <FormElement labelText="SITE" htmlFor="name" errorMessage={stateErrors.name}>
                    <input
                        placeholder="Organization Name"
                        name="name"
                        type="text"
                        value={formData.name}
                        onChange={handleChange}
                    />
                </FormElement>
                
                <br />

                <FormElement labelText="ID" htmlFor="id" errorMessage={stateErrors.customer_id}>
                    <input
                        placeholder="Infusionsoft Id"
                        name="customer_id"
                        type="text"
                        value={formData.customer_id}
                        onChange={handleIdChange}
                    />
                </FormElement>
                
                <br />
                <FormElement labelText="SITE LIMIT" htmlFor="site_limit" errorMessage={stateErrors.site_limit}>
                    <input
                        placeholder="Site Limit"
                        name="site_limit"
                        type="text"
                        value={formData.site_limit}
                        onChange={handleLimitChange}
                    />
                </FormElement>
                <br />

                <FormElement labelText="ACTS" htmlFor="acts">
                    {ActsReducer.all && ActsReducer.all.map(act => {
                        return (
                            <Checkbox
                                checked={formData.acts.includes(parseInt(act.id))}
                                onChange={handleActs}
                                className={styles.checkbox}
                                key={`${act.id}-asdasd`}
                                labelText={`${act.name} (${moment(act.created_at).format('MM/DD/YYYY')})`}
                                value={act.id}
                            />
                        );
                    })}
                </FormElement>


            </div>

            <div className={styles["modal-footer"]}>
                <Button
                    text="CANCEL"
                    color="secondary"
                    onClick={() => props.setShowModal(false)}
                />
                <Button
                    text="CREATE"
                    className={styles.create}
                    onClick={(e) => addModal(e)}
                />
            </div>
        </Modal>
    );
};

const mapStateToProps = state => ({
    ActsReducer: state.ActsReducer,
});

const mapDispatchToProps = {
    createOrgAction,
    loadActsAction,
    loadActsAllAction,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AddOrgModal);
